import { render, staticRenderFns } from "./HeaderAvatarPop.vue?vue&type=template&id=0c2440fc&scoped=true"
import script from "./HeaderAvatarPop.vue?vue&type=script&lang=ts"
export * from "./HeaderAvatarPop.vue?vue&type=script&lang=ts"
import style0 from "./HeaderAvatarPop.vue?vue&type=style&index=0&id=0c2440fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2440fc",
  null
  
)

export default component.exports